import { Separator } from '@sorrem/ui';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './StatRow.module.scss';

interface StatRowProps {
    label: string;
    value: number | undefined;
    /** Flashes the value green or red as it rises or falls (core stats, as gear and attributes change). */
    flashOnChange?: boolean;
}

/** One row of a stat list (a `<dl>`): its label, a rule, and its value. */
export function StatRow({ label, value, flashOnChange = false }: StatRowProps): JSX.Element {
    const shownValue = value ?? 0;
    // The value last seen and how it last moved; each move replays the flash (a new key restarts it).
    const [change, setChange] = useState<{ value: number; count: number; direction: 'increase' | 'decrease' | null }>(
        { value: shownValue, count: 0, direction: null },
    );
    if (flashOnChange && change.value !== shownValue) {
        setChange({ value: shownValue, count: change.count + 1, direction: shownValue > change.value ? 'increase' : 'decrease' });
    }

    return (
        <div className={styles.statRow}>
            <dt className={styles.label}>{label}</dt>
            <Separator className={styles.filler} />
            <dd
                key={change.count}
                className={classNames(
                    styles.value,
                    change.direction === 'increase' && styles.increaseFlash,
                    change.direction === 'decrease' && styles.decreaseFlash,
                )}
            >
                {shownValue}
            </dd>
        </div>
    );
}
